module.exports = __webpack_public_path__ + "static/media/success.402cde22.svg";